import { FC, PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/auth.context.tsx';

const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
	const { isAuthenticated } = useContext(AuthContext);

	// if user is already logged in redirect to home page
	if (isAuthenticated) {
		return (
			<Navigate
				to="/admin/dashboard"
				replace
			/>
		);
	}

	return (
		<section className="flex dark:bg-dark-bg">
			<div className="container h-dvh px-5 py-10">
				<div className="mx-auto grid h-full max-w-[500px] items-center">{children}</div>
			</div>
		</section>
	);
};

export default AuthLayout;
